import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import { fetchWishlist } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlist/actionCreators';
import { getWishlist } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlist/selectors';
import { WishlistDetailedType } from 'b2b-common/core/account/api/wishlists';

type UseWishlistEffectReturnType = RemoteRecord<WishlistDetailedType>;

const useWishlistEffect = (wishlistId: string): UseWishlistEffectReturnType => {
  const dispatch = useDispatch();
  const wishlistDetails = useSelector(
    useCallback((state: State) => getWishlist(state, wishlistId), [wishlistId]),
  );

  useEffect(() => {
    dispatch(fetchWishlist(wishlistId));
  }, [wishlistId]);

  return wishlistDetails;
};

export type { UseWishlistEffectReturnType };
export { useWishlistEffect };
